import React from 'react';

import { FormContent } from 'app/components/FormContent';
import { useForm } from './useForm';
import { FormProps } from './Form.interfaces';
import { useStyles } from './Form.styles';

const Form = (props: FormProps) => {
  const {
    controlsList,
    renderActionButton,
    renderFooter,
    renderScreenContentContainer,
    renderValidationMessage,
    renderFormRowContainer,
    renderSectionHeading,
    renderSection,
    label,
    formName,
    SectionProps,
    isLoading,
    disabled,
    actionButtonTitle,
    newAmbassadorStyle,
  } = props;

  const classes = useStyles();

  const { screens, activeScreen, onSubmit } = useForm(props);

  return (
    <>
      {label && <h3 className={classes.heading}>{label}</h3>}
      <FormContent
        newAmbassadorStyle={newAmbassadorStyle}
        SectionProps={SectionProps}
        form={formName}
        screens={screens}
        formName={formName}
        isLoading={isLoading}
        disabled={disabled}
        activeScreen={activeScreen}
        onSubmit={onSubmit}
        actionButtonTitle={actionButtonTitle}
        controlsList={controlsList}
        renderActionButton={renderActionButton}
        renderFooter={renderFooter}
        renderScreenContentContainer={renderScreenContentContainer}
        renderValidationMessage={renderValidationMessage}
        renderFormRowContainer={renderFormRowContainer}
        renderSectionHeading={renderSectionHeading}
        renderSection={renderSection}
        classes={props.classes}
      />
    </>
  );
};

export default Form;
